import React, { useState, useEffect } from 'react';
import { useSpring, animated } from 'react-spring';
import { Link } from 'gatsby';
import ContainerContent from '../3_layouts/ContainerContent.js';
import TransitionInView from '../0_transitions/TransitionInview.js';
import Button from '../1_components/Button';
import IconMenu from '../5_assets/svg/icons/menu.svg';
import IconClose from '../5_assets/svg/icons/close.svg';
import Logo from '../5_assets/svg/logos/logo.svg';
import { CONTACT_EMAIL } from '../constants/contact';

const navItems = [
   { to: '/', text: 'Home' },
   { to: '/#about', text: 'About' },
   { to: '/#work', text: 'Work' },
   { to: '/#contact', text: 'Contact' },
   // { to: '/blog', text: 'Articles' },
   //    { to: "/about#side-projects", text: "Creative Projects" },
];

const NavItems = ({ navItems, isHomePage }) => (
   <div className="hidden md:inline-block md:px-13 md:py-4 bg-stone-950/20 backdrop-blur-sm border border-surface-1 rounded-4xl">
      <ul className={`flex items-center space-x-12`}>
         {/* <li>
            <Link to={'/'} title={'Home'}>
               <Logo className=" h-4 w-4 text-link" />
            </Link>
         </li> */}

         {navItems.map((item, i) => (
            <li key={i}>
               <Link to={item.to} title={item.text}>
                  <p className={`${isHomePage ? 'text-body-secondary--bright' : 'text-body-primary--dark'} body-xs text-link uppercase tracking-wide`}>{item.text}</p>
               </Link>
            </li>
         ))}
         {/* <Button
            buttonSize="xs"
            isExternalLink={true}
            href="mailto:iampaolotodde@gmail.com"
            label="Contact"
            iconLeft={''}
            textCustomClasses={'uppercase'}
            containerCustomClasses={`border-transparent bg-transparent backdrop-blur-md`}
            hasShadow={false}
         /> */}
      </ul>
   </div>
);

const MobileNavItems = ({ navItems, onClick }) => (
   <div className="space-top-header bg-surface-1 h-[2800px] pl-6">
      <ul className="w-full space-y-1">
         {/* <span className="inline-block mb-4 text-5xl rotate-90">☞</span> */}
         {navItems.map(
            (item, i) =>
               item.text !== 'Contact' && (
                  <li key={i} onClick={onClick} className="text-left">
                     <Link to={item.to} title={item.text} stripHash>
                        <div className="inline-flex items-start space-x-1.5 ">
                           {/* <span className="mr-4 pt-2 text-[2.3rem]">☞</span> */}
                           <p className="header-md">{item.text}</p>
                        </div>
                     </Link>
                  </li>
               )
         )}
         <li>
            <Button
               buttonSize="md"
               isExternalLink={true}
               href={`mailto:${CONTACT_EMAIL}`}
               label="Contact"
               iconLeft={''}
               textCustomClasses={''}
               containerCustomClasses={``}
               hasShadow={false}
            />
         </li>
      </ul>
   </div>
);

const Navigation = ({ pathname = '/' }) => {
   const isHomePage = pathname === '/';
   const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
   const [scrollPosition, setScrollPosition] = useState(0);

   useEffect(() => {
      const handleScroll = () => setScrollPosition(window.scrollY);
      window.addEventListener('scroll', handleScroll, { passive: true });
      return () => window.removeEventListener('scroll', handleScroll);
   }, []);

   const toggleMobileNav = () => setIsMobileNavOpen((prev) => !prev);
   const closeMobileNav = () => setIsMobileNavOpen(false);

   const menuAnimation = useSpring({
      transform: isMobileNavOpen ? 'translateX(15%)' : 'translateX(110%)',
      opacity: isMobileNavOpen ? 1 : 1,
      config: { mass: 3, tension: 450, friction: 70 },
   });

   const scrollThreshold = 85;
   const scrollAnimation = ({
      belowThreshold = '-translate-y-20',
      aboveThreshold = '-translate-y-2 lg:-translate-y-[1.5rem]',
   } = {}) => {
      return scrollPosition < scrollThreshold
         ? `transform translate duration-600 ease-in-out ${belowThreshold}`
         : `transform translate duration-400 ease-in-out ${aboveThreshold}`;
   };

   return (
      <header className={`fixed top-0 right-0 left-0 z-50 w-full`}>
         <ContainerContent>
            <div
               className={`${scrollPosition > scrollThreshold ? 'mt-6 md:mt-10' : 'mt-24 md:mt-28'
                  } ${scrollAnimation()}`}
            >
               <animated.div
                  className="absolute -top-10 right-0 bottom-0 left-0 md:hidden z-10"
                  style={menuAnimation}
                  onClick={closeMobileNav}
               >
                  <MobileNavItems navItems={navItems} onClick={closeMobileNav} />
               </animated.div>

               <nav className="">
                  <TransitionInView direction="fromTop">
                     <NavItems navItems={navItems} isHomePage={isHomePage} />
                  </TransitionInView>
                  <button
                     className="md:hidden"
                     onClick={toggleMobileNav}
                     aria-label={isMobileNavOpen ? "Close menu" : "Open menu"}
                     aria-expanded={isMobileNavOpen}
                  >
                     {isMobileNavOpen ? (
                        <IconClose className="text-colour h-8 w-8" />
                     ) : (
                        <IconMenu className="text-colour h-8 w-8" />
                     )}
                  </button>
               </nav>
            </div>
         </ContainerContent>
      </header>
   );
};

export default Navigation;
